import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { ResponseList } from '@p2p/shared/domain';

import { Notification } from '../entities';

import { NotificationsPageParams } from './notifications.model';

const actionFeatureKey = 'Notifications';

export const loadNotificationsList = createAction(
    `[${actionFeatureKey}/API] Load Notifications List`,
    props<{ pageParams?: NotificationsPageParams }>()
);
export const loadNotificationsListSuccess = createAction(
    `[${actionFeatureKey}/API] Load Notifications List Success`,
    props<{ response: ResponseList<Notification> }>()
);
export const loadNotificationsListFailure = createAction(
    `[${actionFeatureKey}/API] Load Notifications ListFailure `,
    props<{ error: HttpErrorResponse }>()
);

export const setPageParams = createAction(
    `[${actionFeatureKey}] Set Page Params`,
    props<{ pageParams: NotificationsPageParams }>()
);

export const makeNotificationRead = createAction(
    `[${actionFeatureKey}/API] Make Notification Read`,
    props<{ id: number }>()
);
export const makeNotificationReadSuccess = createAction(
    `[${actionFeatureKey}/API] Make Notification Read Success`,
    props<{ id: number }>()
);
export const makeNotificationReadFailure = createAction(
    `[${actionFeatureKey}/API] Make Notification Read Failure`,
    props<{ id: number }>()
);

export const loadUnreadCount = createAction(`[${actionFeatureKey}/API] Load Unread Count`);
export const loadUnreadCountSuccess = createAction(
    `[${actionFeatureKey}/API] Load Unread Count Success`,
    props<{ unreadCount: number }>()
);
export const loadUnreadCountFailure = createAction(
    `[${actionFeatureKey}/API] Load Unread Count Failure`,
    props<{ error: HttpErrorResponse }>()
);

export const startUnreadCountPolling = createAction(`[${actionFeatureKey}] Start Unread Count Polling`);
